import React, { Component, PropTypes } from 'react';
import { Paper, TextField, RaisedButton } from 'material-ui';
import { Link } from 'react-router-dom';
import { Validation, fieldValidatorCore } from 'react-validation-framework';
import validator from 'validator';
import { css } from 'aphrodite';
import { getValueFromChangeEvent, changeCallbackCaller } from '../../utils';
import styles from './auth-style';

export default class ForgotPassword extends Component {
  static propTypes = {
    authError: PropTypes.shape({
      code: PropTypes.string,
      message: PropTypes.string,
    }),
    push: PropTypes.func.isRequired,
    firebase: PropTypes.objectOf(PropTypes.func).isRequired,
  }

  static defaultProps = {
    authError: null,
  }

  state = {
    email: '',
  }

  componentWillMount() {
    fieldValidatorCore.addSupport('TextField', getValueFromChangeEvent, changeCallbackCaller, 'errorText');
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleKeyDown = e => e.key === 'Enter' && this.handleSubmit()

  handleSubmit = () => {
    if (!this.isValid()) return false;
    const { firebase: { resetPassword } } = this.props;
    const { email } = this.state;
    return resetPassword(email).then(() => this.props.push('/login'));
  }

  isValid = () => fieldValidatorCore.checkGroup('forgot').isValid;

  render() {
    const { authError } = this.props;
    const { email } = this.state;

    return (
      <div className={css(styles.page)}>
        {authError &&
          <span className={css(styles.authError)}>
            {authError.message}
          </span>
        }
        <Paper className={css(styles.paper)}>
          <h1 className={css(styles.header)}>Reset Your Password</h1>

          <Validation
            group="forgot"
            validators={[{
              validator: val => !validator.isEmpty(val),
              errorMessage: 'Email is required',
            }, {
              validator: val => validator.isEmail(val),
              errorMessage: 'Email must be valid',
            }]}
          >
            <TextField
              fullWidth
              className={css(styles.textField)}
              floatingLabelText="Email"
              name="email"
              onChange={this.handleChange}
              onKeyDown={this.handleKeyDown}
              value={email}
            />
          </Validation>

          <RaisedButton
            fullWidth
            className={css(styles.btn)}
            label="Submit"
            onClick={this.handleSubmit}
          />
        </Paper>
        <Link to="/login" className={css([styles.link, styles.create])}>Back to Login</Link>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/auth/forgot.js